/* fichier JS de base commun quelques soient les versions du projet web */
// charge bootstrap => nécessite jquery et popper => il est préférable de décomposer bootstrap en sélectionnant les modules communs utilisés sur toutes les pages du site
// import 'bootstrap'
// exemples en ne chargeant que les modules ci-dessous (généralement utilisés pour le header du site)
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/util'

// lazy loading => https://github.com/aFarkas/lazysizes
import lazySizes from 'lazysizes'
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'

// pas de ./ car on résout dans theme donc déjà déclaré dans resolve.modules dans webpack.base.js
// l'extension n'est pas obligatoire car connue dans resolve.extensions, ne fonctionnera pas si il y a des fichiers de différentes extensions portant le même nom (ex: bootstrap.css et bootstrap.js dans le même dossier)
// import 'bootstrap/scss/bootstrap'
import './scss/_bootstrap_custom'

// global styles
import './scss/custom'

// Scripts librairies
import './js/libs/misc'
import './js/libs/utils' // lazy loading https://github.com/aFarkas/lazysizes
lazySizes.cfg.expand = 80
lazySizes.cfg.expFactor = 1
$('body').removeClass('no-js')

// lazysizes : add simple support for background images :
document.addEventListener('lazybeforeunveil', function (e) {
  const bg = e.target.getAttribute('data-bg')
  if (bg) e.target.style.backgroundImage = 'url(' + bg + ')'
})

// Scroll to top
async function getScrollToTop () {
  import('./js/libs/scrollToTop/scrollToTop.js').then(() => {
    $.scrollUp({
      easingType: 'linear',
      topSpeed: 300,
      scrollSpeed: 400,
      animation: 'fade',
      scrollText: '<i class="icon-up"></i>'
    })
  })
}

// sticky header
function sticky () {
  const $s = $('.sticky-top')
  if ($(window).scrollTop() > 100) { $s.addClass('nav-bg') } else { $s.removeClass('nav-bg') }
}

// Actions principales communes à toutes les pages
$(document).ready(function () {
  // smooth scroll js
  $(window).scroll(function () {
    if ($(this).scrollTop() >= 100) { getScrollToTop() }
    sticky()
  })

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    Waypoint.refreshAll()
  })

  sticky()
})
